import {
  createLightTheme,
  createDarkTheme,
  BrandVariants,
  Theme,
} from '@fluentui/react-components';

/**
 * cloudpunks Brand Colors
 *
 * Primary Colors:
 * - Dunkelblau (Dark Blue): #001E3C - Primary brand color, dark backgrounds
 * - Beige: #C5C3AE - Secondary, light backgrounds
 *
 * Accent:
 * - Gelb (Yellow): #FFD62F - CTAs and highlights only
 *
 * Text:
 * - Weiß (White): #FFFFFF - Text on dark backgrounds
 *
 * Typography:
 * - Headlines: Jost Semibold
 * - Body: Roboto Regular
 * - Emphasis: Roboto Bold
 */

// Brand color ramp based on cloudpunks Dunkelblau (#001E3C)
// Generated from primary brand color with appropriate light/dark variations
const cloudpunksBrand: BrandVariants = {
  10: '#000D18',
  20: '#001424',
  30: '#001B30',
  40: '#001E3C', // Base dark blue
  50: '#0A2D4D',
  60: '#153D5E',
  70: '#214D6F',
  80: '#2D5E80', // Primary brand shade
  90: '#3A6F91',
  100: '#4880A2',
  110: '#5691B3',
  120: '#65A2C4',
  130: '#75B3D5',
  140: '#86C4E6',
  150: '#98D5F7',
  160: '#ABE6FF',
};

// Create light theme with cloudpunks branding
const lightThemeBase = createLightTheme(cloudpunksBrand);

// Create dark theme with cloudpunks branding
const darkThemeBase = createDarkTheme(cloudpunksBrand);

// Custom overrides for cloudpunks design
export const cloudpunksLightTheme: Theme = {
  ...lightThemeBase,
  // Typography - use Jost for display, Roboto for body
  fontFamilyBase: "'Roboto', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
  fontFamilyMonospace: "'Roboto Mono', 'Consolas', monospace",
  // Custom color overrides
  colorBrandBackground: '#001E3C', // Dunkelblau
  colorBrandBackgroundHover: '#0A2D4D',
  colorBrandBackgroundPressed: '#001424',
  colorBrandForeground1: '#001E3C',
  colorBrandForeground2: '#0A2D4D',
  // Accent colors for CTAs
  colorCompoundBrandBackground: '#FFD62F', // Gelb for primary buttons
  colorCompoundBrandBackgroundHover: '#E6C12A',
  colorCompoundBrandBackgroundPressed: '#CCA825',
  // Neutral adjustments for beige tones
  colorNeutralBackground2: '#F5F4F0', // Light beige tint
  colorNeutralBackground3: '#ECEAE3', // Slightly darker beige tint
};

export const cloudpunksDarkTheme: Theme = {
  ...darkThemeBase,
  fontFamilyBase: "'Roboto', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
  fontFamilyMonospace: "'Roboto Mono', 'Consolas', monospace",
  colorBrandBackground: '#001E3C',
  colorNeutralBackground1: '#001E3C', // Dark blue background
  colorNeutralBackground2: '#001424',
  colorNeutralForeground1: '#FFFFFF',
};

// Export the primary theme to use
export const cloudpunksTheme = cloudpunksLightTheme;
